// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAiY4i0fIcRYDnm8t9I2iocEDW31meOQAs",
  authDomain: "express-abouhamama.firebaseapp.com",
  projectId: "express-abouhamama",
  storageBucket: "express-abouhamama.firebasestorage.app",
  messagingSenderId: "1088059030340",
  appId: "1:1088059030340:web:34c1258ca0442092c7f511",
  measurementId: "G-LZQ75P3NVL"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, db, auth, analytics };
